import callApi from 'lib/callApi';

import { Subscription } from '../types';

export const subscribeProduct = async (
  vendorName: string,
  productName: string | null,
) => {
  return subscribe(vendorName, productName);
};

export const subscribeVendor = async (vendorName: string) => {
  return subscribe(vendorName, null);
};

export const subscribe = async (
  vendorName: string,
  productName: string | null,
) => {
  try {
    await callApi(
      'opencve/subscribe/',
      'POST',
      {},
      { product_name: productName, vendor_name: vendorName },
    );
    // handle success case here, e.g. show success message to user
    return true;
  } catch (error) {
    console.error(error);
    // handle error case here, e.g. show error message to user
  }
  return false;
};

export const unsubscribe = async (subscriptionId: number) => {
  try {
    await callApi(`opencve/unsubscribe/${subscriptionId}/`, 'DELETE', {});
    // handle success case here, e.g. show success message to user
    return true;
  } catch (error) {
    console.error(error);
    // handle error case here, e.g. show error message to user
  }
  return false;
};

export const getVendorSubscription = (
  vendorSubscriptions: Subscription[],
  vendorName: string,
): Subscription | undefined => {
  if (
    vendorSubscriptions &&
    vendorSubscriptions.length > 0 &&
    vendorSubscriptions.some((s) => s.vendor_name === vendorName)
  ) {
    return vendorSubscriptions.find((sub) => sub.vendor_name === vendorName);
  }
  return undefined;
};

export const getProductSubscription = (
  productSubscriptions: Subscription[],
  vendorName: string,
  productName: string,
): Subscription | undefined => {
  if (
    productSubscriptions &&
    productSubscriptions.length > 0 &&
    productSubscriptions.some(
      (s) => s.vendor_name === vendorName && s.product_name === productName,
    )
  ) {
    return productSubscriptions.find(
      (sub) =>
        sub.vendor_name === vendorName && sub.product_name === productName,
    );
  }

  return undefined;
};
